<template>
	<div>
		<table>
			<thead>
				<tr class="body-text-1">
					<th class="th-life-event__type " @click="sortColumn('description')">
						<div class="th-sort">
							<span>{{ $t('description') }}</span>
							<span v-if="sortedColumn === 'description'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th
						class="th-life-event__interest"
						@click="sortColumn('cmsInterest.name')"
					>
						<div class="th-sort">
							<span>{{ $t('interest') }}</span>
							<span v-if="sortedColumn === 'cmsInterest.name'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-life-event__event" @click="sortColumn('isAmountAdded')">
						<div class="th-sort">
							<span>{{ $t('lifeEventImpact') }}</span>
							<span v-if="sortedColumn === 'isAmountAdded'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th
						class="th-life-event__event"
						@click="sortColumn('mustChooseAccount')"
					>
						<div class="th-sort">
							<span>{{ $t('eventType') }}</span>
							<span v-if="sortedColumn === 'mustChooseAccount'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-life-event__active" @click="sortColumn('isActive')">
						<div class="th-sort">
							<span>{{ $t('active') }}</span>
							<span v-if="sortedColumn === 'isActive'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-life-event__actions">{{ $t('actions') }}</th>
				</tr>
			</thead>
			<tbody class="body-text-2">
				<tr class="search-row">
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchDescription" />
						</label>
					</td>
					<td></td>
					<td></td>
					<td></td>
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchActive" />
						</label>
					</td>
					<td></td>
				</tr>
				<tr
					v-for="(row, index) in displayedData"
					:key="index"
					class="table-row"
				>
					<td class="description-cell">{{ row.description }}</td>
					<td class="interest-cell">{{ row.cmsInterest.name }}</td>
					<td>{{ getAmountAddedName(row.isAmountAdded) }}</td>
					<td class="interest-cell">
						{{ getEventTypeName(row.mustChooseAccount) }}
					</td>
					<td>{{ getActiveName(row.isActive) }}</td>
					<td class="td-center">
						<button class="action-button" @click="editRow(row)">
							<svgicon v-if="isEnable" name="pencil"></svgicon>
							<svgicon v-if="!isEnable" name="search"></svgicon>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<ja-pagination
			:current="currentPage"
			:data-per-page="itemsPerPage"
			:data-count="filteredData.length"
			@changePage="setAllPage"
		></ja-pagination>
	</div>
</template>
<script>
import Pagination from '@/components/AdminSection/elements/Pagination';
import { choices, amountAdded, isActive } from '@/helpers/constants';
import AdminFacility from '@/mixins/AdminFacility';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';
import '@/components/icons/cms/arrowDown';
import '@/components/icons/cms/arrowUp';
export default {
	components: {
		jaPagination: Pagination
	},
	mixins: [AdminFacility],
	props: {
		data: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			showMessageDeletionModal: false,
			sortedColumn: null,
			sortOrder: 1,
			isSorted: false,
			searchDescription: '',
			searchActive: '',
			currentPage: 1,
			itemsPerPage: 15
		};
	},
	computed: {
		filteredData() {
			let filteredData = this.data.filter(
				row =>
					row.description
						.toLowerCase()
						.includes(this.searchDescription.toLowerCase()) &&
					this.getActiveName(row.isActive)
						.toLowerCase()
						.includes(this.searchActive.toLowerCase())
			);

			if (this.sortedColumn) {
				filteredData = filteredData.sort((a, b) => {
					const fieldA = a[this.sortedColumn];
					const fieldB = b[this.sortedColumn];
					return (fieldA > fieldB ? -1 : 1) * this.sortOrder;
				});
			}
			return filteredData;
		},
		displayedData() {
			const start = (this.currentPage - 1) * this.itemsPerPage;
			const filteredData = this.filteredData.slice(
				start,
				start + this.itemsPerPage
			);
			return filteredData;
		},
		totalPages() {
			return Math.ceil(this.data.length / this.itemsPerPage);
		},
		showPagination() {
			return this.totalPages > 1;
		},
		isEnable() {
			return (
				(this.isSuperAdmin || this.isUSAAdmin) && this.selectedFacilityId == 0
			);
		}
	},
	watch: {
		displayedData() {
			this.currentPage = this.currentPage <= 0 ? 1 : this.currentPage;
		}
	},
	methods: {
		getEventTypeName(isChoice) {
			for (const choice of choices) {
				if (choice.value === isChoice) {
					return choice.name;
				}
			}
			const isUndefined = choices.find(c => c.value === null).name;
			return isUndefined;
		},
		getAmountAddedName(isAmountAdded) {
			for (const added of amountAdded) {
				if (added.value === isAmountAdded) {
					return this.$t(added.name);
				}
			}
			return '--';
		},
		getActiveName(onActive) {
			for (const added of isActive) {
				if (added.value === onActive) {
					return this.$t(added.name);
				}
			}
			return '--';
		},
		sortTable() {
			this.sortOrder = this.sortOrder * -1;
			this.sortedColumn = null;
		},
		sortColumn(column) {
			this.sortedColumn = column;
			this.sortOrder = this.sortOrder * -1;
			this.isSorted = !this.isSorted;
		},
		changePage(pageNumber) {
			this.currentPage = pageNumber;
		},
		editRow(row) {
			this.$emit('editRow', row);
		},
		setAllPage(page) {
			this.currentPage = page;
		}
	}
};
</script>
<style lang="scss" scoped>
table {
	width: 100%;
	border-collapse: collapse;
	margin-top: 10px;
}
.td-input {
	padding: 0;
}
.th-life-event {
	&__type {
		width: 30%;
	}
	&__interest {
		width: 14%;
	}
	&__event {
		width: 19%;
	}
	&__active {
		width: 10%;
	}
	&__actions {
		width: 8%;
	}
}
.th-sort {
	cursor: pointer;
	display: flex;
	justify-content: space-between;
}
.td-center {
	text-align: center;
	text-align: -webkit-center;
}
.description-cell {
	max-width: 280px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.interest-cell {
	max-width: 70px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.custom-input {
	display: flex;
	border-radius: 4px;
	border: 1px solid #ddd;
	box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.15);
	padding: 7px 5px;
	margin: 1px;
	gap: 5px;
}

.custom-input input {
	border: none;
	outline: none;
	width: 100%;
}
.custom-input:focus-within {
	outline: 2px solid $hover-state;
	box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.15);
}
.action-button {
	background-color: transparent;
	border: none;
	cursor: pointer;
	padding: 0 10px;
}

th,
td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

th {
	background-color: #ffff;
}
</style>
